import { useState } from "react";
import ProjectCard from "./ProjectCard";
import FeaturedProject from "./FeaturedProject";

function Projects({ projects }) {
  const [showAllProjects, setShowAllProjects] = useState(false);

  const featuredProject = projects.find((project) => project.featured);
  const otherProjects = projects.filter((project) => !project.featured);

  const visibleProjects = showAllProjects
    ? otherProjects
    : otherProjects.slice(0, 3);

  const hasMoreProjects = otherProjects.length > 3;

  return (
    <section id="projects" className="section">
      <div className="container">
        <span className="section-eyebrow">Projects</span>
        <h2 className="section-title">Selected Work</h2>

        {featuredProject && <FeaturedProject project={featuredProject} />}

        <h3 className="projects-subtitle">Other Projects</h3>

        <div className="projects-grid">
          {visibleProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>

        {hasMoreProjects && (
          <div className="projects-toggle">
            <button
              type="button"
              className="projects-toggle-button"
              onClick={() => setShowAllProjects((current) => !current)}
            >
              {showAllProjects ? "Show Less" : "View All Projects"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Projects;
